import React, { createContext, useContext, useReducer } from 'react';


const reportingState = (
  // localStorage.getItem('reportingState')
  //   ?
  //   {
  //     ...JSON.parse(localStorage.getItem('reportingState'))
  //   }
  //   :
  {
    search: null,
    scenario: null,
    scenarios: null,
    settingsScenarios: null,

    module: null,

    pickers: {
      groups: [],
      locations: { all: [], show: [] }
    },
    selected: {
      groups: [],
      locations: []
    },

    reportingColumns: [],

    filterModel: {
      items: [],
      linkOperator: "and"
    }
  }
);


export const ReportingContext = createContext();
export const ReportingProvider = ({ reducer, children }) => (
  <ReportingContext.Provider value={useReducer(reducer, reportingState)}>
    {children}
  </ReportingContext.Provider>
);

export const useReportingContext = () => useContext(ReportingContext);
